module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"提现","tipsTitle":"提现注意事项"}}')
  delete Component.options._Ctor
}
